import { transType } from './static'

export const getTransTypeUri = (
  transTypeId,
  data,
  permissions = [],
  isCashBank = false,
  force = false,
  props,
) => {
  let url = ''
  let name = ''

  if (!isCashBank) {
    if (transTypeId === transType.REPORT_SALES_PER_SALES_PERSON) {
      url = '/reports/sales-per-sales-person'
      name = 'report_sales_per_sales_person'
    }
    if (transTypeId === transType.CLOSING) {
      if (data.id) {
        url = `/closing/detail/${data.id}`
      } else {
        url = `/closing`
      }
      name = 'accounts'
    }
    if (transTypeId === transType.MATERIAL_REQUEST) {
      if (data.id) {
        url = `/warehouses/material-requests/detail/${data.id}`
      } else {
        url = `/warehouses/material-requests`
      }
      // `name` sengaja dikosongkan → gerbang permission di bawah dilewati. BE belum
      // menerbitkan node permission untuk material request, dan klik baris di list
      // juga sudah tidak digerbangi, jadi menebak nama node hanya akan mematikan
      // link ini diam-diam. Isi `name` begitu node-nya terbit.
      // Catatan: 617001 tidak masuk rentang `> INVOICE(5) && < REVERSAL(21)` di bawah,
      // jadi tidak akan tertimpa cabang transaksi kas & bank.
    }
    if (transTypeId === transType.MATERIAL_ISSUE) {
      if (data.id) {
        url = `/warehouses/material-issues/detail/${data.id}`
      } else {
        url = `/warehouses/material-issues`
      }
      // `name` dikosongkan dengan alasan yang sama seperti MATERIAL_REQUEST di atas
    }
    if (transTypeId === transType.QUOTE) {
      if (data.id) {
        url = `/sales/quotes/detail/${data.id}`
      } else {
        url = `/sales/quotes`
      }
      name = 'quotes'
    }
    if (transTypeId === transType.PURCHASE_ORDER) {
      if (data.id) {
        url = `/purchases/purchaseOrders/detail/${data.id}`
      } else {
        url = `/purchases/purchaseOrders`
      }
      name = 'purchase_orders'
    }
    if (
      (transTypeId > transType.INVOICE && transTypeId < transType.REVERSAL) ||
      transTypeId === transType.RECEIVE_PROFORMA_INVOICE ||
      transTypeId === transType.RECEIVE_PROFORMA_ORDER
    ) {
      if (data.id) {
        url = `/banks/${data.accountId}/transaction/detail/${data.id}`
      } else {
        url = `/banks/detail/${data.accountId}/transactions`
      }
      name = 'cash_bank'
    }
    if (transTypeId === transType.ORDER) {
      if (data.id) {
        url = `/sales/orders/detail/${data.id}`
      } else {
        url = `/sales/orders`
      }
      name = 'orders'
    }
    if (transTypeId === transType.DELIVERY) {
      if (data.id) {
        url = `/sales/deliveries/detail/${data.id}`
      } else {
        url = `/sales/deliveries`
      }
      name = 'deliveries'
    }
    if (transTypeId === transType.EXPENSE) {
      if (data.id) {
        url = `/expenses/detail/${data.id}`
      } else {
        url = `/expenses`
      }
      name = 'expenses'
    }
    if (transTypeId === transType.PURCHASE_ORDER) {
      if (data.id) {
        url = `/purchases/purchaseorders/detail/${data.id}`
      } else {
        url = `/purchases/purchaseorders`
      }
      name = 'purchase_orders'
    }
    if (transTypeId === transType.PURCHASE_REQUEST) {
      if (data.id) {
        url = `/purchases/purchaserequests/detail/${data.id}`
      } else {
        url = `/purchases/purchaserequests`
      }
      name = 'purchase_requests'
    }
    if (transTypeId === transType.PURCHASE_INVOICE) {
      if (data.id) {
        url = `/purchases/purchaseinvoices/detail/${data.id}`
      } else {
        url = `/purchases/purchaseinvoices`
      }
      name = 'purchase_invoices'
    }
    if (transTypeId === transType.JOIN_PURCHASE_INVOICE && data.id) {
      url = `/purchases/purchaseinvoices/join-invoice/detail/${data.id}`
      name = 'purchase_invoices'
    }
    if (transTypeId === transType.PURCHASE_QUOTE) {
      if (data.id) {
        url = `/purchases/quotes/detail/${data.id}`
      } else {
        url = `/purchases/quotes`
      }
      name = 'purchase_quotes'
    }
    if (transTypeId === transType.PURCHASE_DELIVERY) {
      if (data.id) {
        url = `/purchases/deliveries/detail/${data.id}`
      } else {
        url = `/purchases/deliveries`
      }
      name = 'purchase_deliveries'
    }
    if (transTypeId === transType.DELIVERY_RECAP) {
      if (data.id) {
        url = `/zap/recap-deliveries/detail/${data.id}`
      } else {
        url = `/sales/deliveries`
      }
      name = 'zap_delivery_recap'
    }
    if (transTypeId === transType.INVOICE) {
      if (data.id) {
        url = `/sales/invoices/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'invoices'
    }
    if (transTypeId === transType.INVOICE_RECAP) {
      if (data.id) {
        url = `/zap/recap-invoices/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'zap_invoice_recap'
    }
    if (transTypeId === transType.CANVASSING) {
      if (data.id) {
        url = `/zap/canvassing/detail/${data.id}`
      } else {
        url = '/zap/canvassing'
      }
      name = 'zap_canvassing'
    }
    if (transTypeId === transType.REVERSAL) {
      if (data.id) {
        url = `/accounts/conversionbalances/reversal_detail/${data.id}`
      } else {
        url = `/accounts/conversionbalances`
      }
      name = 'conversion_balance'
    }
    if (transTypeId === transType.JOIN_INVOICE) {
      if (data.id) {
        url = `/sales/invoices/join-invoice/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'invoices'
    }
    if (transTypeId === transType.JOIN_PURCHASE_INVOICE) {
      if (data.id) {
        url = `/purchases/purchaseinvoices/join-invoice/detail/${data.id}`
      } else {
        url = `/purchases/purchaseinvoices`
      }
      name = 'purchase_invoices'
    }
    if (
      transTypeId === transType.RECEIVE_JOIN_INVOICE_PAYMENT ||
      transTypeId === transType.PURCHASE_JOIN_INVOICE_PAYMENT
    ) {
      if (data.id) {
        url = `/banks/${data.accountId}/transaction/detail/${data.id}`
      } else {
        url = `/banks/detail/${data.accountId}/transactions`
      }
      name = 'cash_bank'
    }
    if (transTypeId === transType.OPENING_BALANCE) {
      if (data.id) {
        url = `/accounts/conversionbalances/opening_balance/${data.id}`
      } else {
        url = `/accounts/conversionbalances`
      }
      name = 'conversion_balances'
    }
    if (transTypeId === transType.MANUAL_JOURNAL || transTypeId === transType.BANK_MANUAL_JOURNAL) {
      if (data.id) {
        url = `/manual-journal/detail/${data.id}`
      } else {
        url = `/manual-journal`
      }
      name = 'manual_journal'
    }
    if (
      transTypeId === transType.CREATE_FIXED_ASSET ||
      transTypeId === transType.INITIAL_DEPRECIATION ||
      transTypeId === transType.DEPRECIATION ||
      transTypeId === transType.DISPOSAL
    ) {
      if (data.id) {
        url = `/fixed-assets/transaction/${data.id}`
      } else {
        url = `/fixed-assets`
      }
      name = 'fixed_assets'
    }
    if (transTypeId === transType.WAREHOUSE_TRANSFER) {
      if (data.id) {
        url = `/warehouses/${data.warehouseId}/transfer/detail/${data.id}`
      } else {
        url = `/warehouses/detail/${data.warehouseId}`
      }
      name = 'warehouse_transfer'
    }
    if (transTypeId === transType.WAREHOUSE_TRANSFER_GROUP && data.id) {
      url = `/warehouses/transfer-group/detail/${data.id}`
      name = 'warehouse_transfer'
    }
    if (transTypeId === transType.SEND_TRANSFER) {
      if (data.id) {
        url = `/banks/${data.bank_account_id}/transaction/detail/${data.id}`
      } else {
        url = `/banks/detail/${data.bank_account_id}/transactions`
      }
      name = 'cash_bank'
    }
    if (transTypeId === transType.USER) {
      url = data?.id ? `/settings/users?id=${data.id}` : '/settings/users'
      name = 'users'
    }
    if (transTypeId === transType.TRANSLATION) {
      url = `/settings/translation`
      name = 'translation'
    }
    if (transTypeId === transType.ROLE) {
      if (data.id) {
        url = `/settings/roles/edit/${data.id}`
        name = 'roles_edit'
      } else {
        url = '/settings/roles'
        name = 'roles'
      }
    }
    if (transTypeId === transType.OPTION) {
      url = `/settings/company`
      name = 'company'
    }
    if (transTypeId === transType.STOCK_ADJUSTMENT) {
      if (data.id) {
        url = `/warehouses/${data.warehouseId}/stock-adjustment/detail/${data.id}`
      } else {
        url = `/warehouses/detail/${data.warehouseId}`
      }
      name = 'stock_adjustment'
    }
    if (transTypeId === transType.TERM) {
      url = `/settings/expenses/terms`
      name = 'terms'
    }
    if (transTypeId === transType.TAX) {
      url = `/settings/taxes`
      name = 'taxes'
    }
    if (transTypeId === transType.WAREHOUSE) {
      if (data.id) {
        const warehouse = props?.warehouses_has_role?.find(
          (_warehouse) => _warehouse.id.toString() === data.id.toString(),
        )

        if (warehouse) {
          url = `/warehouses/detail/${data.id}`
          name = 'inventory'
        }
      } else {
        url = `/warehouses`
        name = 'inventory'
      }
    }
    if (transTypeId === transType.PRODUCT || transTypeId === transType.GLOBAL_SEARCH_PRODUCT) {
      if (data.id) {
        url = `/products/detail/${data.id}`
      } else {
        url = `/products`
      }
      name = 'products'
    }
    if (transTypeId === transType.NUMBER) {
      url = `/settings/automatic-sequencing`
      name = 'automatic_sequencing'
    }
    if (transTypeId === transType.LAYOUT_INVOICE) {
      url = `/settings/layout-invoice`
      name = 'layout_invoice'
    }
    if (transTypeId === transType.FIXED_ASSET) {
      if (data.id) {
        url = `/fixed-assets/detail/${data.id}`
      } else {
        url = `/fixed-assets`
      }
      name = 'fixed_assets'
    }
    if (transTypeId === transType.FIXED_ASSET_UPGRADE) {
      if (data.fixedAssetId && data.id) {
        url = `/fixed-assets/${data.fixedAssetId}/upgrade/detail/${data.id}`
      } else {
        url = `/fixed-assets`
      }
      name = 'fixed_assets'
    }
    if (transTypeId === transType.CONVERSION_BALANCE) {
      url = `/accounts/conversionbalances`
      name = 'conversion_balances'
    }
    if (transTypeId === transType.CONTACT || transTypeId === transType.GLOBAL_SEARCH_CONTACT) {
      url = `/contacts`
      if (data.isDetail || (data.id && transTypeId === transType.GLOBAL_SEARCH_CONTACT)) {
        url = `/contacts/detail/${data.id}`
      }
      name = 'contacts'
    }
    if (transTypeId === transType.ACCOUNT || transTypeId === transType.GLOBAL_SEARCH_ACCOUNT) {
      if (data.id) {
        url = `/accounts?id=${data.id}`
        name = 'accounts'
      } else {
        url = `/reports/account-transaction/${data.userId}`
        name = 'reports'
      }
    }
    if (transTypeId === transType.BILLING) {
      url = `/settings/billing`
      name = 'billing'
    }
    if (
      transTypeId === transType.CREDIT_MEMO_PAYMENT ||
      transTypeId === transType.RECEIVE_SALES_ORDER_PAYMENT ||
      transTypeId === transType.DEBIT_MEMO_PAYMENT ||
      transTypeId === transType.PURCHASE_ORDER_PAYMENT ||
      transTypeId === transType.BANK_DEBIT_MEMO ||
      transTypeId === transType.BANK_CREDIT_MEMO
    ) {
      if (data.id) {
        url = `/banks/${data.accountId}/transaction/detail/${data.id}`
      } else {
        url = `/banks/detail/${data.accountId}/transactions`
      }
      name = 'cash_bank'
    }
    if (transTypeId === transType.CREDIT_MEMO) {
      if (data.id) {
        url = `/credit-memo/detail/${data.id}`
      } else {
        url = `/contacts`
      }
      name = 'contacts'
    }
    if (transTypeId === transType.DEBIT_MEMO) {
      if (data.id) {
        url = `/debit-memo/detail/${data.id}`
      } else {
        url = `/contacts`
      }
      name = 'contacts'
    }
    if (transTypeId === transType.RETURN) {
      url = `/sales/returns/detail/${data.id}`
      name = 'invoices'
    }
    if (transTypeId === transType.PURCHASE_RETURN) {
      url = `/purchases/returns/detail/${data.id}`
      name = 'purchase_invoices'
    }
    if (transTypeId === transType.PRODUCT_CONVERSION) {
      url = `/products/conversions/detail/${data.id}`
      name = 'products'
    }
    if (transTypeId === transType.ORDER) {
      if (data.id) {
        url = `/sales/orders/detail/${data.id}`
      } else {
        url = `/sales/orders`
      }
      name = 'orders'
    }
    if (transTypeId === transType.RECURRING_INVOICE) {
      url = `/sales/invoices/recurring/edit/${data.id}?transTypeId=${transType.INVOICE}`
      name = 'invoices'
    }
    if (transTypeId === transType.RECURRING_ORDER) {
      url = `/sales/orders/recurring/edit/${data.id}?transTypeId=${transType.ORDER}`
      name = 'orders'
    }
    if (transTypeId === transType.RECURRING_PURCHASEINVOICE) {
      url = `/purchases/purchaseinvoices/recurring/edit/${data.id}?transTypeId=${transType.PURCHASE_INVOICE}`
      name = 'purchase_invoices'
    }
    if (transTypeId === transType.RECURRING_PURCHASEORDER) {
      url = `/purchases/purchaseorders/recurring/edit/${data.id}?transTypeId=${transType.PURCHASE_ORDER}`
      name = 'purchase_orders'
    }
    if (transTypeId === transType.RECURRING_EXPENSE) {
      url = `/expenses/recurring/edit/${data.id}?transTypeId=${transType.EXPENSE}`
      name = 'expenses'
    }
    if (transTypeId === transType.RECURRING_MANUALJOURNAL) {
      url = `/manual-journal/recurring/edit/${data.id}?transTypeId=${transType.MANUAL_JOURNAL}`
      name = 'manual_journal'
    }
    if (transTypeId === transType.RECURRING_CASHBANK) {
      url = `/banks/${data.accountId}/recurring/edit/${data.id}?transTypeId=${transType.CASH_BANK}`
      name = 'cash_bank'
    }
    if (transTypeId === transType.TAG) {
      if (data.id) {
        url = `/settings/tags/detail/${data.id}`
      } else {
        url = `/settings/tags`
      }
      name = 'tags'
    }
    if (transTypeId === transType.INVOICE_PAYMENT_CREDIT_MEMO) {
      if (data.id) {
        url = `/invoice-payment-credit-memo/detail/${data.id}`
      }
    }
    if (transTypeId === transType.PURCHASE_INVOICE_PAYMENT_DEBIT_MEMO) {
      if (data.id) {
        url = `/purchaseinvoice-payment-debit-memo/detail/${data.id}`
      }
    }
    if (transTypeId === transType.UNREALIZED_GAIN) {
      if (data.id) {
        url = `/unrealized-gain/detail/${data.id}`
      }
    }
    if (transTypeId === transType.PROFORMA_INVOICE) {
      if (data.id) {
        url = `/sales/invoices/proforma/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'invoices'
    }
    if (transTypeId === transType.PROFORMA_ORDER) {
      if (data.id) {
        url = `/sales/orders/proforma/detail/${data.id}`
      } else {
        url = `/sales/orders`
      }
      name = 'orders'
    }

    if (transTypeId === transType.FLEET) {
      if (data.id) {
        url = `/zap/fleets/detail/${data.id}`
      } else {
        url = '/zap/fleets'
      }

      name = 'zap_fleet'
    }

    if (transTypeId === transType.ZAP_ROUTE) {
      if (data.id) {
        url = `/zap/routes/detail/${data.id}`
      } else {
        url = '/zap/routes'
      }

      name = 'zap_route'
    }

    if (transTypeId === transType.BUDGET_MANAGEMENT) {
      if (data.id) {
        url = `/reports/budget-management?selectedBudget=${data.id}`
      } else {
        url = `/reports/budget-management`
      }
    }
  } else {
    // eslint-disable-next-line no-lonely-if
    if (transTypeId === transType.EXPENSE_PAYMENT || transTypeId === transType.EXPENSE_WITHOLDING) {
      if (data.id) {
        url = `/expenses/detail/${data.id}`
      } else {
        url = `/expenses`
      }
      name = 'expenses'
    } else if (
      transTypeId === transType.PURCHASE_PAYMENT ||
      transTypeId === transType.PURCHASE_INVOICE_WITHOLDING ||
      transTypeId === transType.PURCHASE_SHIPPING_COSTS
    ) {
      if (data.id) {
        url = `/purchases/purchaseinvoices/detail/${data.id}`
      } else {
        url = `/purchases/purchaseinvoices`
      }
      name = 'purchase_invoices'
    } else if (transTypeId === transType.PURCHASE_ORDER_PAYMENT) {
      if (data.id) {
        url = `/purchases/purchaseorders/detail/${data.id}`
      } else {
        url = `/purchases/purchaseorders`
      }
      name = 'purchase_orders'
    } else if (
      transTypeId === transType.RECEIVE_INVOICE_PAYMENT ||
      transTypeId === transType.INVOICE_WITHOLDING ||
      transTypeId === transType.SALES_SHIPPING_COSTS
    ) {
      if (data.id) {
        url = `/sales/invoices/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'invoices'
    } else if (transTypeId === transType.RECEIVE_JOIN_INVOICE_PAYMENT) {
      if (data.id) {
        url = `/sales/invoices/join-invoice/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'invoices'
    } else if (transTypeId === transType.PURCHASE_JOIN_INVOICE_PAYMENT) {
      if (data.id) {
        url = `/purchases/purchaseinvoices/join-invoice/detail/${data.id}`
      } else {
        url = `/purchases/purchaseinvoices`
      }
      name = 'purchase_invoices'
    } else if (transTypeId === transType.RECEIVE_PROFORMA_INVOICE) {
      if (data.id) {
        url = `/sales/invoices/proforma/detail/${data.id}`
      } else {
        url = `/sales/invoices`
      }
      name = 'invoices'
    } else if (transTypeId === transType.RECEIVE_PROFORMA_ORDER) {
      if (data.id) {
        url = `/sales/orders/proforma/detail/${data.id}`
      } else {
        url = `/sales/orders`
      }
      name = 'orders'
    } else if (
      transTypeId === transType.RECEIVE_MONEY ||
      transTypeId === transType.SPEND_MONEY ||
      transTypeId === transType.EXPENSE ||
      transTypeId === transType.MANUAL_JOURNAL ||
      transTypeId === transType.PRODUCT
    ) {
      url = `/reports/account-transaction/${data.id}?date_from=${data.trans_date}&date_to=${
        data.date_to || data.trans_date
      }`
      name = 'reports'
    } else if (transTypeId === transType.REGISTER_FIXED_ASSET) {
      if (data.id) {
        url = `/fixed-assets/detail/${data.id}`
      } else {
        url = `/fixed-assets`
      }
      name = 'fixed_assets'
    } else if (
      transTypeId === transType.CREDIT_MEMO_PAYMENT ||
      transTypeId === transType.BANK_CREDIT_MEMO
    ) {
      if (data.id) {
        url = `/credit-memo/detail/${data.id}`
      } else {
        url = `/contacts`
      }
      name = 'contacts'
    } else if (
      transTypeId === transType.DEBIT_MEMO_PAYMENT ||
      transTypeId === transType.BANK_DEBIT_MEMO
    ) {
      if (data.id) {
        url = `/debit-memo/detail/${data.id}`
      } else {
        url = `/contacts`
      }
      name = 'contacts'
    } else if (transTypeId === transType.RECEIVE_SALES_ORDER_PAYMENT) {
      if (data.id) {
        url = `/sales/orders/detail/${data.id}`
      } else {
        url = `/sales/orders`
      }
      name = 'orders'
    } else if (
      transTypeId === transType.INVOICE_PAYMENT_WITHOLDING ||
      transTypeId === transType.PURCHASE_INVOICE_PAYMENT_WITHOLDING ||
      transTypeId === transType.EXPENSE_PAYMENT_WITHOLDING ||
      transTypeId === transType.JOIN_INVOICE_PAYMENT_WITHOLDING ||
      transTypeId === transType.PURCHASE_JOIN_INVOICE_PAYMENT_WITHOLDING
    ) {
      if (data.id) {
        url = `/banks/${data.accountId}/transaction/detail/${data.id}`
      }
      name = 'cash_bank'
    }
  }

  // override permission
  if (props?.permission) {
    name = props.permission
  }

  if (name) {
    // `permissions` sudah flat `string[]` → cek presence langsung.
    const findPermission = permissions.includes(name)

    if (!findPermission && !force) {
      url = ''
    }
  }

  if (url) {
    return `${url}${props?.suffixUrl ?? ''}`
  }

  return url
}
